import { api } from 'common';
import ResultsItem from './ResultsItem';

interface Props {
  currentProviders: api.PrevisitProvider.SafeProviderWithPractices[];
  pageOffset: number;
  pageLimit: number;
}

const ResultsList: React.FC<Props> = ({
  currentProviders,
  pageOffset,
  pageLimit,
}) => {
  return (
    <>
      {currentProviders
        .slice(pageOffset, pageOffset + pageLimit)
        .map((provider, idx) => (
          <ResultsItem key={provider.id} provider={provider} idx={idx} />
        ))}
    </>
  );
};
export default ResultsList;
